"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var override_1 = require("../../override");
var FallbackStrategy_1 = require("../constants/FallbackStrategy");
var constants_1 = require("../constants");
var conditions_1 = require("../../conditions");
var types_1 = require("../../../types");
var ClientSideBehavior = (function () {
    function ClientSideBehavior(name, condition, fallback, isForAgoda, defaultForB2B, configProvider) {
        if (condition === void 0) { condition = conditions_1.noCondition; }
        if (isForAgoda === void 0) { isForAgoda = types_1.AgodaToggle.Enabled; }
        if (defaultForB2B === void 0) { defaultForB2B = types_1.B2BDefaultToggle.Enabled; }
        var _this = this;
        this.evaluateCondition = function (resolverFactory, externalProvider) {
            try {
                var overriddenBehaviors = externalProvider.getOverrideValues();
                if ((0, override_1.shouldOverride)(overriddenBehaviors, _this.name))
                    return (0, override_1.evaluateOverride)(overriddenBehaviors, _this.name);
                var whitelabelId = _this.getWhitelabelId(resolverFactory);
                var implicitWhiteLabelEnabled = whitelabelId === 1
                    ? _this.isForAgoda === types_1.AgodaToggle.Enabled
                    : _this.isEnabledForWhitelabel(externalProvider, resolverFactory, whitelabelId);
                return (implicitWhiteLabelEnabled &&
                    _this.condition.evaluate(resolverFactory));
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error.name === 'ConditionEvalError') {
                        console.log('Error evaluating condition: ', error.message);
                    }
                    if (error.name === 'OverrideEvalError') {
                        console.log('Error evaluating override: ', error.message);
                    }
                }
                return _this.fallbackHandler(error);
            }
        };
        this.getConfiguration = function (resolverFactory) { var _a; return (_a = _this.configProvider) === null || _a === void 0 ? void 0 : _a.getConfiguration(resolverFactory); };
        this.describe = function () {
            return "".concat(_this.name, ": ").concat(_this.condition.describe());
        };
        this.getWhitelabelId = function (resolverFactory) {
            var resolver = resolverFactory.getResolver(constants_1.Variant.WhiteLabelId);
            var whitelabelId = resolver.get();
            if (typeof whitelabelId !== 'number')
                throw new Error("WhitelabelId is not a number but ".concat(whitelabelId));
            return whitelabelId;
        };
        this.fallbackHandler = function (error) {
            switch (_this.fallback) {
                case FallbackStrategy_1.FallbackStrategy.Enable:
                    return true;
                case FallbackStrategy_1.FallbackStrategy.Disable:
                    return false;
                case FallbackStrategy_1.FallbackStrategy.ThrowException:
                    throw error;
                default:
                    return false;
            }
        };
        this.name = name;
        this.condition = condition;
        this.fallback = fallback;
        this.isForAgoda = isForAgoda;
        this.defaultForB2B = defaultForB2B;
        this.configProvider = configProvider;
    }
    ClientSideBehavior.prototype.isEnabledForWhitelabel = function (externalProvider, resolverFactory, whitelabelId) {
        var behaviorToFeatureMap = externalProvider.getBehaviorToFeatureMapping(whitelabelId);
        var featureName = behaviorToFeatureMap.get(this.name);
        if (!(featureName === null || featureName === void 0 ? void 0 : featureName.length))
            return this.defaultForB2B === types_1.B2BDefaultToggle.Enabled;
        var featureResolver = resolverFactory.getLookupResolver(constants_1.Variant.WhiteLabelFeature);
        return featureResolver.getBy(featureName) === featureName;
    };
    return ClientSideBehavior;
}());
exports.default = ClientSideBehavior;
